<div style="margin-left:10px;margin-right:10px; " class="component">
  <div>
    <mat-drawer-container class="drawer-container">
      <mat-drawer #drawer class="sidedrawer-nav" mode="side" opened>
        <app-ccc-report-parameters-component (searchClicked)="searchClicked($event)"
                                         (cancelSearchClicked)="cancelSearchClicked()"
                                         [searchInProgress]="searchInProgress"
                                         [internalUser]="internalUser">
        </app-ccc-report-parameters-component>
      </mat-drawer>
      <mat-drawer-content>
        <div class="sidedrawer-content">
          <div class="drawer-button" (click)="toggleDrawer()">
            <button *ngIf="drawer.opened" mat-icon-button><mat-icon>arrow_back_ios</mat-icon></button>
            <button *ngIf="!drawer.opened" mat-icon-button><mat-icon>arrow_forward_ios</mat-icon></button>
          </div>
          <div class="report-content">
            <h3>Crosses, Category, and Confidence Report</h3>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
              <mat-tab id="resultsTab">
                <ng-template mat-tab-label>
                  <span class="labelBold">Results</span>
                </ng-template>
                <app-xref-display-component [xrefData]="resultsData"
                                        [searching]="searchInProgress"
                                        [hasSearched]="hasSearched"
                                        [loadError]="loadError"
                                        [canEdit]="false"
                                        [internalUser]="internalUser"
                                        [xrefColumnDisplayOrder]="columnOrderSetUp"
                                        [xrefColumnRename]="renameColumns"
                                        [allowColumnChanges]="true"
                                        [updatingXrefs]="false"
                                        [doubleHeader]="false"
                                        [singleExport]="!isMultiExport()"
                                        [multiExport]="isMultiExport()"
                                        [exportButtonData]="exportSelection()"
                                        [maxDisplayedColumns]="19"
                                        (exportClicked)="exportReport($event)">
                </app-xref-display-component>
              </mat-tab>
              <mat-tab id="exportsTab">
                <ng-template mat-tab-label>
                  <span class="labelBold">My Exports</span>
                </ng-template>
                <app-file-download #fileDownload [exportType]="'CCC'"></app-file-download>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>
